import { FC, useContext } from 'react';
// CSS and assets
import '@pages/checkout/components/SecurePayment/style.scss';
import './style.scss';
import { paymentInfo } from '@src/pages/checkout/types';
import { ReloadInitResponseContext } from '@src/pages/checkout/components/SecurePayment';
import { MappedPaymentComponentsType } from '@src/global/types/types';

interface IProps {
  paymentInitData: paymentInfo;
  paymentMethod: string;
  paymentComponentMap: MappedPaymentComponentsType;
}

const WpsPayment: FC<IProps> = ({ paymentMethod, paymentComponentMap }) => {
  const { payment } = useContext(ReloadInitResponseContext);

  const PaymentComponent = paymentComponentMap[paymentMethod];

  return (
    <>
      <div className="iframeStyle">
        {<PaymentComponent payment={payment} />}
      </div>
    </>
  );
};

export default WpsPayment;
